var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_7315_393895)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7315_393895)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.570312,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8047 27.6818C23.2468 27.6818 23.6719 27.6165 24.0732 27.4947C23.8556 27.5644 23.6318 27.6165 23.4032 27.6496L22.8146 27.735L22.2105 27.6493C21.9742 27.6158 21.743 27.5619 21.5186 27.4894C21.925 27.6145 22.3561 27.6818 22.8047 27.6818ZM22.7609 31.2389H22.8551H23.5109H25.0661V31.249H20.5499V31.2389H22.1051H22.7609ZM24.8796 22.795C24.8796 24.1071 23.8998 25.0796 22.8047 25.0796C21.7096 25.0796 20.7298 24.1071 20.7298 22.795V17.0336C20.7298 15.7216 21.7096 14.749 22.8047 14.749C23.8998 14.749 24.8796 15.7216 24.8796 17.0336V22.795Z",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.085,
    y1: 11.4687,
    x2: 34.7124,
    y2: 34.0961,
    stroke: "#707070",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_7315_393895",
    x: -15,
    y: -14.4297,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7315_393895"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7315_393895",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7315_393895"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.570312,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDisable);
export default __webpack_public_path__ + "static/media/audioDisable.db102eab9511c0b2d05b80a68f71807e.svg";
export { ForwardRef as ReactComponent };